import React from 'react';

import BackgroundImage from 'gatsby-background-image';
import { graphql, useStaticQuery } from 'gatsby';

const FreedomBanner3 = () => {
  const { windowview } = useStaticQuery(graphql`
    query {
      windowview: file(relativePath: { eq: "c5-window.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 85) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  return (
    <div className="bg-ganen-gray-2">
      <div className="box-container">
        <div className="row h-500 h-md-600 px-3">
          <div className="col-12 col-lg-6">
            <BackgroundImage
              fluid={windowview.childImageSharp.fluid}
              className="h-400 h-md-270 w-md-75 mx-auto"
            ></BackgroundImage>
          </div>
          <div className="col-12 col-lg-6 text-center">
            <h5 className="fs-20 ganen-green-bold pb-2 pt-3">
              Close your Outdoor Blinds on a rainy day
            </h5>

            <p>
              <em>
                “Create more space in your balcony, create a smart space.”
              </em>
            </p>

            <div className="y-2 p-lg-4">
              <div>
                With a location-based weather forecast built into our app,
                <br className="d-none d-sm-block" />
                automatically close the blinds when it rains.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreedomBanner3;
